// extracted by mini-css-extract-plugin
export default {"wrapper":"src-modules-page-blocks-HeaderTertiary-style__wrapper_qeKCM"};